import styled from '@emotion/styled'
import { Button, palette, spacing, Text, typography } from 'main/ui'
import darken from 'polished/lib/color/darken'

export const Container = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
  min-height: 208px;
  width: 100%;
  height: 208px;
  left: 0px;
  top: 0px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  border: 1px solid ${palette.chrome};
  box-sizing: border-box;
  border-radius: 8px;
`

export const AvatarContainer = styled.div<{ url: string | null }>`
  align-items: center;
  margin-top: ${spacing.majorScale(3)}px;
  background-image: ${({ url }) => (url ? `url(${url})` : 'none')};
  background-size: contain;
  color: ${palette.chrome};
  height: 160px;
  width: 160px;
  justify-content: center;

  &:hover {
    border-color: ${darken(0.1, palette.chrome)};
    color: ${darken(0.1, palette.chrome)};
  }
`

export const TextContainer = styled.div`
  grid-column: 1 / 3;
  grid-row: 1 / 2;
  max-width: 404px;
  margin: ${spacing.majorScale(3)}px ${spacing.majorScale(3)}px 0px ${spacing.majorScale(3)}px;
`

export const Legend = styled.div`
  font-family: ${typography.fontFamily.ui};
  font-size: ${typography.fontSize.text}px;
  font-weight: ${typography.fontWeight.bold};
  font-style: normal;
  line-height: 25px;
  text-align: left;
  letter-spacing: 0px;
  height: 20px;
  padding-bottom: ${spacing.majorScale(3)}px;
`

export const Description = styled(Text)`
  font-size: ${typography.fontSize.label}px;
  font-weight: ${typography.fontWeight.regular};
  letter-spacing: 0px;
  padding: ${spacing.majorScale(2)}px 0 ${spacing.majorScale(1)}px 0;
  color: ${palette.slate};
`

export const ButtonContainer = styled.div`
  width: 240px;
`

export const StyledButton = styled(Button)`
  margin-top: ${spacing.majorScale(3)}px;

  width: 240px;
  height: 35px;
  border-radius: 3px;
  border: 1px solid ${palette.chrome};
`
